const openCounters = (box) => {
  const d = [];
  d.push({
    icon: "/icons/icon_time.png",
    counter: box.minutes.open,
    description: "In Open",
  });
  d.push({
    icon: "/icons/icon_time.png",
    counter: box.minutes.active,
    description: "In Active",
  });
  d.push({
    icon: "/icons/icon_point.png",
    counter: box.points.others + box.points.own,
    description: "Points",
  });
  return d;
};

const savedCounters = (box) => {
  const d = [];
  return d;
};

export { openCounters, savedCounters };
